// src/components/Navbar.js
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function Navbar() {
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  const [activeIndex, setActiveIndex] = useState(0);
  const linksRef = useRef([]);
  const tubelightRef = useRef(null);

  // ✅ Your admin UID(s)
  const ADMIN_UIDS = ["MDSy4dIHEnOi3JMescY0PztvkK13"];
  const isAdmin = currentUser && ADMIN_UIDS.includes(currentUser.uid);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Designer", path: "/designer" },
    { name: "Cart", path: "/cart" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  useEffect(() => {
    const currentIndex = navLinks.findIndex(
      (link) => link.path === location.pathname
    );
    setActiveIndex(currentIndex >= 0 ? currentIndex : 0);
  }, [location.pathname]);

  useEffect(() => {
    if (linksRef.current[activeIndex] && tubelightRef.current) {
      const link = linksRef.current[activeIndex];
      tubelightRef.current.style.left = `${link.offsetLeft + link.offsetWidth / 4}px`;
    }
  }, [activeIndex]);

  return (
    <nav className="navbar fixed top-0 left-0 w-full z-50 bg-pink-700 text-white shadow-md">
      <div className="container mx-auto flex justify-between items-center relative py-4">
        <Link to="/" className="text-2xl font-bold tracking-wide">
          LisaNails
        </Link>

        <div className="flex space-x-6 relative items-center">
          {/* Main nav links with tubelight */}
          {navLinks.map((link, index) => (
            <Link
              key={link.path}
              to={link.path}
              ref={(el) => (linksRef.current[index] = el)}
              className={activeIndex === index ? "active" : ""}
              onClick={() => setActiveIndex(index)}
            >
              {link.name}
            </Link>
          ))}

          {/* ✅ Admin link – only visible for admin user */}
          {isAdmin && (
            <Link
              to="/admin"
              className="px-3 py-1 rounded-md border border-white/40 text-sm hover:bg-white/10"
            >
              Admin
            </Link>
          )}

          {/* Auth section */}
          {currentUser ? (
            <>
              <Link to="/profile">Profile</Link>
              <button
                onClick={logout}
                className="text-sm hover:underline ml-2"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link to="/signup">Signup</Link>
            </>
          )}

          {/* Tubelight underline */}
          <div className="tubelight" ref={tubelightRef}>
            <div className="light-ray"></div>
          </div>
        </div>
      </div>
    </nav>
  );
}
